import _ from 'lodash';
import errorReporter from '@app/errorReporter';
import {
  formatActionTaken,
  formatNonAgentStatus,
  formatPhoneNumber,
  hasNonAgentNotificationFeature,
  featureEnabled,
} from 'utils';
import { parseLabelFromString } from 'contexts';
import template from './appointment_deny.html';
import { NA_TYPE_MAP } from '../../constants/index';

angular.module('bb.appointments').component('bbAppointmentDeny', {
  bindings: {},
  controller: AppointmentDenyCtrl,
  controllerAs: 'vm',
  template,
});

AppointmentDenyCtrl.$inject = [
  '$scope',
  '$resource',
  '$rootScope',
  '$routeParams',
  'loadContacts',
  '$q',
  'AppointmentBookService',
];

function AppointmentDenyCtrl(
  $scope,
  $resource,
  $rootScope,
  $routeParams,
  loadContacts,
  $q,
  AppointmentBookService,
) {
  const vm = this;
  vm.auth = $rootScope.auth;
  vm.viewDashAppointment = $rootScope.viewDashAppointment;
  vm.openContactDrawer = $rootScope.openContactDrawer;

  vm.naTypeMap = NA_TYPE_MAP;

  const Appointment = $resource('/appointments/:appointmentId', {
    appointmentId: '@appointmentId',
  });
  const AppointmentConfig = $resource(
    '/listing/:listingId/appointments/config',
    { listingId: '@listingId' },
  );
  const Deny = $resource('/appointments/send/:appointmentId/deny', {
    appointmentId: '@appointmentId',
  });
  const AppointmentList = $resource('/listing/:listingId/appointments', {
    listingId: '@listingId',
  });
  const DenyCoop = $resource('/appointments/send/:appointmentId/deny_coop', {
    appointmentId: '@appointmentId',
  });

  vm.hasNonAgentNotificationFeature = featureEnabled(
    'nonAgentNotificationFeature',
  );

  vm.details = {
    not_before_11: true,
  };

  vm.action = {
    tab: 'history',
    restrictions: 'weekly',
  };

  vm.options = {
    is_deny: true,
    button_label: 'Send Denial',
    header_label: 'SEND DENIAL',
    label: 'Refusal Information for Co-Op Agent',
    custom_message: 'REASON FOR DENIAL (optional)',
    custom_message_placeholder: 'Why was this showing denied?',
  };

  Appointment.get({ appointmentId: $routeParams.appointmentId })
    .$promise.then(data => {
      vm.appointment = data.appointment;
      vm.listing = data.listing;
      vm.listingLink = `#/listing/${vm.listing.id}/view`;
      vm.mlsTypes = data.listing.org?.mlsTypes.length
        ? data.listing.org.mlsTypes
        : null;

      AppointmentConfig.get({ listingId: vm.listing.id })
        .$promise.then(appointmentConfig => {
          const agentIds = appointmentConfig.contacts
            .filter(contact => contact.type === 'Agent')
            .map(contact => contact.contactId);
          loadContacts($resource, vm, $q, vm.listing.id, agentIds).catch(
            errorReporter.error,
          );

          vm.appointmentConfig = appointmentConfig;

          vm.cancellation = {
            appointmentId: $routeParams.appointmentId,
            details: vm.details,
            notify: _.clone(data.appointment.notify),
          };

          if (
            featureEnabled('nonAgentNotificationFeature') &&
            vm.appointment.coop.nonAgentId &&
            !featureEnabled('customContactDashboardFeature')
          ) {
            vm.cancellation.notify = {
              text: false,
              email: Boolean(vm.appointment.coop.approvedNonAgent),
              office: !vm.appointment.coop.approvedNonAgent,
            };
            vm.cancellation.actionTaken = '';
          }
        })
        .catch(errorReporter.error)
        .finally(() => {
          vm.dataLoaded = true;
        });
    })
    .catch(errorReporter.error);

  vm.hasListingContact = contact =>
    Object.keys(vm.listingContacts || {}).includes(
      contact.id || contact.contactId,
    );

  vm.formatNonAgentStatus = formatNonAgentStatus;

  // Move me into utils later
  vm.formatNonAgentNotification = () => {
    const naNameMap = {
      'Pest Control': 'PEST CONTROL',
      Photographer: 'PHOTOGRAPHER',
    };
    let naName = naNameMap[vm.appointment.type] || 'HOME INSPECTOR/APPRAISER';
    if (!vm.appointment.coop.isNotAgent) {
      naName = 'CUSTOM AGENT';
    }
    return `(${naName} ${
      vm.appointment.coop.approvedNonAgent ? '' : 'NOT '
    }NOTIFIED)`;
  };

  vm.formatActionTaken = ({
    status,
    originalTime,
    actionTaken,
    isPending,
    nonAgentNotified,
    date,
    auditEntry,
  }) => {
    return formatActionTaken(
      {
        date,
        auditEntry,
        status,
        originalTime,
        actionTaken,
        isPending,
        nonAgentNotified,
      },
      vm.appointment.type,
      vm.appointment.coop,
      vm.mustCallContacts,
      vm.appointment.history,
    );
  };

  vm.formatPhoneNumber = formatPhoneNumber;

  vm.loadAppointments = () => {
    if (vm.appointmentsLoaded) return;

    AppointmentList.query({ listingId: vm.listing.id })
      .$promise.then(appointments => {
        vm.appointments = appointments;
        vm.appointmentsLoaded = true;
      })
      .catch(errorReporter.error);
  };

  AppointmentBookService.queryAppointmentTextDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.textDeliveryLog = data;
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentEmailDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.emailDeliveryLog = data;
    })
    .catch(errorReporter.error);

  vm.selectSpecialDay = day => {
    vm.restrictDate = day;
  };

  AppointmentBookService.queryAppointmentPushNotificationDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.pushNotificationDeliveryLog = data;
    })
    .catch(errorReporter.error);

  vm.simplifyPhoneInfo = phoneInfo => {
    let receivingText = false;
    const mustCall = [];
    if (phoneInfo?.length) {
      receivingText = phoneInfo.reduce((acc, phone) => {
        if (phone.mustCall && phone.number) mustCall.push(phone.number);
        if (phone.sendSms) return true;
        return acc;
      }, false);
    }
    return { receivingText, mustCall };
  };

  vm.submit = () => {
    vm.dataLoaded = false;
    if (!vm.cancellation.details) {
      vm.cancellation.details = {};
    }
    const { actionDetails } =
      vm.appointment.history[vm.appointment.history.length - 1];
    if (vm.cancellation.notify.office) {
      vm.cancellation.details.message = actionDetails
        ? actionDetails.message
        : null;
    } else {
      vm.cancellation.details.message =
        vm.cancellation.details.message || vm.details.message;
    }
    if (
      vm.appointment.listingContactTimeChange &&
      vm.appointment.keepOriginalAppointment
    ) {
      vm.cancellation.keepOriginalAppointment = true;
    }

    const deny = vm.appointment.listingContactTimeChange
      ? new DenyCoop({ ...vm.cancellation, isAdmin: true })
      : new Deny(vm.cancellation);

    deny.$save(() => {
      $rootScope.viewNextAppointmentPage(
        $routeParams.appointmentId,
        false,
        'deny',
        vm.listing.id,
      );
    });
  };

  vm.isNonAdminListingAgent = () => {
    const isAgentRole = vm.auth.role === 'AGENT';
    const isListingAgent = vm.listing.repsObjectIds.includes(vm.auth.id);
    return isAgentRole && isListingAgent;
  };

  $scope.$watch(
    'vm.cancellation',
    () => {
      const { cancellation } = vm;
      if (!cancellation) return;

      if (cancellation.isPending) {
        vm.options.button_label = 'Attempted';
      } else {
        if (cancellation.notify.email) {
          vm.options.button_label = 'Send Denial';
        }
        if (cancellation.notify.office) {
          vm.options.button_label = 'Delivered';
        }
      }
    },
    true,
  );

  $rootScope.$watch('labelOverrideMap', () => {
    vm.relabelListingAvailability = availability =>
      $rootScope.labelOverrideMap[parseLabelFromString(availability)]?.label ||
      availability;
  });
}
